module.exports = __webpack_public_path__ + "static/media/some-most-used-javascript-string-number-array-and-object.614da472.jpg";